// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"AppLayout_collapsed__3uVX-","expanded":"AppLayout_expanded__1YN_9"};